<template>
  <div class="applyAll">
    <ApplyNoalert ref="ApplyNoalert" />
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline selectForm"
    >
      <el-form-item label="项目名称：">
        <el-input
          v-model="formInline.name"
          placeholder="请输入项目名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      class="applyTable"
      ref="multipleTable"
      :data="tableDataAll"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      ><!--@row-click="handleClickDetail"-->
      <el-table-column prop="name" label="项目名称" align="left" width="300">
        <!--<template slot-scope="scope">
          <p>
            <span style="padding-right: 20px;">{{ scope.row.time }}</span
            ><span>编号：2120004000003</span>
          </p>
          <p>{{ scope.row.name }}</p>
          <p><i class="el-icon-document-copy"></i><span>招商引资</span></p>
        </template>-->
      </el-table-column>
      <el-table-column
        prop="price"
        label="金额(元)"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="companyCode"
        label="统一社会信用代码"
        align="center"
      >
        <!--<template slot-scope="scope">
          <p><i class="el-icon-question"></i>申报：￥{{ scope.row.money }}</p>
          <p>支持|单位</p>
        </template>-->
      </el-table-column>
      <el-table-column prop="deptName" label="部门" align="center">
        <!--<template slot-scope="scope">
          <p><i class="el-icon-question"></i>申报：￥{{ scope.row.money }}</p>
          <p>支持|单位</p>
        </template>-->
      </el-table-column>
      <el-table-column prop="state" label="状态" align="center">
        <!--<template slot-scope="scope">
          <p class="statuColor applying" v-if="scope.row.statu == 1">审核中</p>
          <p class="applying" v-if="scope.row.statu == 6">已兑现</p>
          <p>项目详情</p>
        </template>-->
      </el-table-column>

      <!--<el-table-column label="操作" align="center" width="155">
        <template slot-scope="scope">
          <p v-if="scope.row.statu == 1">
            <i class="el-icon-timer"></i>已审{{ scope.row.auditTime }}小时
          </p>
          <p v-if="scope.row.statu == 1" @click="handleClickDetail()">查看</p>
          <p v-if="scope.row.statu === 2">提交</p>
          <p @click="evaluate()">评价</p>
        </template>
      </el-table-column>-->
    </el-table>
    <div class="applyPagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      class="dialog_rate"
      title="评价"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose0"
    >
      <div class="form-item">
        <span>满意度评价:</span>
        <el-rate v-model="rateValue"></el-rate>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ApplyNoalert from "@/components/ApplyNo_alert.vue";
import { myProjectPageList } from "@/api/noApply";
export default {
  name: "ApplyAll",
  components: {
    ApplyNoalert,
  },
  data() {
    return {
      dialogVisible: false,
      formInline: {
        name: "",
      },
      value1: "",
      rateValue: null,
      currentPage: 1,
      total: 0,
      /*tableDataAll: [
        {
          num: "1",
          name: "北京市高精尖产业发展资金",
          money: "120万元",
          statu: 6, //1.审核中 2.审核通过 3.已驳回 4.待上传数据 5.已兑现 6.已放弃
          statuReason: "",
          time: "2022-03-14  23:00:00",
          auditTime: 60,
        },
        {
          num: "2",
          name: "企业上市补助资金申报表",
          money: "50万元",
          statu: 1,
          statuReason: "",
          time: "2022-03-14  23:00:00",
          auditTime: 60,
        },

        {
          num: "3",
          name: "节能减排科技创新示范企业",
          money: "100万元",
          statu: 2,
          statuReason: "",
          time: "2022-03-14  23:12:00",
          auditTime: 0,
        },
        {
          num: "4",
          name: "科技创新小巨人补贴",
          money: "40万元",
          statu: 2,
          statuReason: "",
          time: "2022-03-14  23:15:00",
          auditTime: 0,
        },
        {
          num: "5",
          name: "企业上市补助资金",
          money: "600万元",
          statu: 1,
          statuReason: "",
          time: "2022-03-16  14:00:00",
          auditTime: 0,
        },
      ],*/
      tableDataAll: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const payload = {
        name: this.formInline.name,
        pageNumber: this.currentPage,
        pageSize: 10,
      };
      /*if (this.formInline.time && this.formInline.time.length == 2) {
        payload.stime = this.formInline.time[0];
        payload.etime = this.formInline.time[1];
      }*/
      myProjectPageList(payload).then(({ data }) => {
        const { code, result, message } = data;
        if (code == 200) {
          this.tableDataAll = result.records;
          this.total = result.total;
        }
      });
    },
    evaluate() {
      this.rateValue = null;
      this.dialogVisible = true;
    },
    handleClose0() {
      this.dialogVisible = false;
    },
    handleClick(row) {
      console.log(row, 33);
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    look() {
      this.$router.push({
        name: "ApplyNo_det",
      });
    },
    appeal() {
      this.$refs.ApplyNoalert.show({
        type: 1,
      });
    },
    upload() {
      this.$refs.ApplyNoalert.show({
        type: 2,
      });
    },
    download() {},
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    handleClickDetail() {
      this.$router.push({
        name: "declareDetail",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.applyAll {
  .applyTab {
    /*border-top: 2px solid #e4e7ed;*/
    /deep/.el-tabs__item {
      padding: 0 20px;
      font-size: 16px;
      height: 50px;
      line-height: 50px;
      color: rgba(56, 56, 56, 1);
    }
    /deep/.selectForm {
      .el-form-item {
        margin-right: 5%;
      }
      .el-date-editor .el-range-separator {
        width: 10%;
      }
    }
  }
  .applyTable {
    &::before {
      height: 0;
    }
    height: 530px;
    overflow: auto;
    /deep/.has-gutter tr th {
      background-color: rgba(250, 250, 250, 1);
    }
    .rejectIcon {
      font-size: 19px;
      margin-left: 3px;
      vertical-align: text-bottom;
    }
    .statuColor::before {
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 5px;
    }
    .applying::before {
      background-color: rgba(24, 144, 255, 1);
    }
    .applypass::before {
      background-color: rgba(67, 207, 124, 1);
    }
    .applyreject::before {
      background-color: rgba(245, 34, 45, 1);
    }
    .uploaddata::before {
      background-color: rgb(25, 207, 231);
    }
    .tocash::before {
      background-color: rgba(255, 141, 26, 1);
    }
    .givrup::before {
      background-color: rgba(0, 0, 0, 0.25);
    }
  }
  .applyPagination {
    text-align: right;
    margin-top: 10px;
  }
  .el-button--primary:focus,
  .el-button--primary:hover {
    background-color: #4988df;
    border-color: #4988df;
  }
  .dialog_rate {
    /deep/ .el-dialog {
      margin-top: 20% !important;
      .form-item {
        display: flex;
        span {
          height: 28px;
          line-height: 28px;
          margin-right: 20px;
        }
        .el-rate {
          height: 30px;
          line-height: 30px;
          .el-rate__item {
            margin-right: 0;
            .el-rate__icon {
              font-size: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
